var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53206 12.4658H2.6045L9.21151 5.84932L8.13907 4.77534L1.53206 11.3918V12.4658ZM12.4863 4.73699L9.23066 1.51507L10.3031 0.441096C10.5968 0.147032 10.9576 0 11.3855 0C11.813 0 12.1735 0.147032 12.4671 0.441096L13.5396 1.51507C13.8332 1.80913 13.9864 2.16405 13.9992 2.57984C14.012 2.99511 13.8715 3.34977 13.5779 3.64384L12.4863 4.73699ZM11.3755 5.86849L3.25563 14H0V10.7397L8.11992 2.60822L11.3755 5.86849ZM8.67529 5.31233L8.13907 4.77534L9.21151 5.84932L8.67529 5.31233Z",
    fill: "#1348FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/EditPencilIcon.245794d193d7f0b01140b557b0ef085d.svg";
export { ForwardRef as ReactComponent };